import { Modal, DatePicker, Typography } from "antd";
import React, {useState} from 'react'
import moment from 'moment'
const { Text } = Typography;

export default function PortfolioStatusModal({
  visible,
  mode,               // 'archive' | 'unarchive'
  onCancel,
  onConfirm
}) {
  const isArchive = mode === 'archive';
  const [expireDate, setExpireDate] = useState(null);
  const afterClose = () => {
    setExpireDate(null)
  }
  return (
    <Modal
      width={550}
      afterClose={afterClose}
      visible={visible}
      title={isArchive ? "是否要解封此作品集" : "是否要从此封存此作品集"}
      onCancel={onCancel}
      onOk={() => onConfirm(expireDate && expireDate.format('YYYY-MM-DD'))}
      okText={isArchive ? "解封" :  "封存"}
      cancelText="取消"
      destroyOnClose
    >
      {/* 封存模式 */}
      {!isArchive && (
        <Text>
          作品集封存后，将不会出现在互联创作平台的「提交到作品集」弹窗中，也不再允许任何人将作品添加进作品集或是移出作品集。
          已经在作品集中的作品允许继续修订。
        </Text>
      )}

      {/* 解封模式 */}
      {isArchive && (
        <>
          <Text>
            作品集解封后，会重新出现在互联创作平台的「提交到作品集」弹窗中，也将重新允许将作品添加进作品集或是移出作品集。
          </Text>

          <div style={{ marginTop: 16 }}>
            <Text strong>作品集封存日期：</Text>
            <DatePicker
              value={expireDate}
              onChange={setExpireDate}
              style={{ marginLeft: 8 }}
              placeholder="请选择封存日期"
              format="YYYY/MM/DD"
              allowClear
              disabledDate={date => {
                console.log(date)
                return date < moment().startOf('day')
                // return date.isBefore(moment(), 'day');
              }}
            />
          </div>

          <Text type="secondary" style={{ display: "block", marginTop: 8 }}>
            到期后作品集会自动被封存，需校区管理员或本团队授课教师才可将其解封。
            <br />
            也可以不设置封存日期，则本作品集将不会自动封存。
          </Text>
        </>
      )}
    </Modal>
  );
}
